export default function formatMoney(amount: number, currency: string) {
  if (!amount || amount === 0) {
    return currency + "0.00";
  } else {
    return currency + amount.toLocaleString();
  }
}
